import CloseIcon from "@mui/icons-material/Close";
import DangerousIcon from "@mui/icons-material/Dangerous";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import InfoIcon from "@mui/icons-material/Info";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";
import SnoozeIcon from "@mui/icons-material/Snooze";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { Box } from "@mui/material";
import React from "react";
import { TalentStatus } from "../../../../features/talents/types/common";

const ProfileIncompleteIcon = () => (
  <Box position="relative" display="inline-flex">
    <PersonAddAlt1Icon sx={{ color: "primary.main" }} />
    <Box position="absolute" top={-8} right={-6} display="flex">
      <InfoIcon sx={{ fontSize: 14, color: "#FF505A" }} />
    </Box>
  </Box>
);

const InterviewPendingIcon = () => (
  <Box position="relative" display="inline-flex">
    <PersonAddAlt1Icon sx={{ color: "primary.main" }} />
    <Box position="absolute" top={-10} right={-6} display="flex">
      <PhoneMissedIcon sx={{ fontSize: 14, color: "#FF505A" }} />
    </Box>
  </Box>
);

const InterviewIcon = () => (
  <Box position="relative" display="inline-flex">
    <PersonAddAlt1Icon sx={{ color: "primary.main" }} />
    <Box position="absolute" top={-8} right={-6} display="flex">
      <EventAvailableIcon sx={{ fontSize: 14, color: "primary.main" }} />
    </Box>
  </Box>
);

const talentStatusMuiIcons: Record<TalentStatus, React.ReactNode> = {
  [TalentStatus.INCOMPLETE]: <ProfileIncompleteIcon />,
  [TalentStatus.NEW]: <PersonAddAlt1Icon sx={{ color: "primary.main" }} />,
  [TalentStatus.INTERVIEW_PENDING]: <InterviewPendingIcon />,
  [TalentStatus.INTERVIEW]: <InterviewIcon />,
  [TalentStatus.ACTIVE]: (
    <ThumbUpIcon sx={{ color: "success.light", width: 20, height: 20 }} />
  ),
  [TalentStatus.LATER]: <SnoozeIcon sx={{ color: "warning.main" }} />,
  [TalentStatus.EMPLOYED_ELSEWHERE]: (
    <ExitToAppIcon sx={{ color: "text.secondary" }} />
  ),
  [TalentStatus.NOT_EMPLOYED]: <DangerousIcon sx={{ color: "error.main" }} />,
  [TalentStatus.DISABLED]: <CloseIcon sx={{ color: "error.main" }} />,
  [TalentStatus.DEACTIVATED]: <CloseIcon sx={{ color: "error.main" }} />,
};

export const getTalentStatusIcon = (status?: TalentStatus): React.ReactNode => {
  if (!status) return null;
  return talentStatusMuiIcons[status];
};
